(function ($) {
    $(function () {

        $('.stage-slider').each(function () {
            var $el = $(this);
            if ($el.children().length === 0) {
                $el.remove();
            } else {
                $el.addClass('has-entries');
            }
        });

        $('.stage-slider.has-entries').slick({
            slidesToShow: 1,
            swipeToSlide: true,
            dots: true,
            adaptiveHeight: true,
            autoplay: true,
            dotsClass: 'slick-dots square'
        });
    });
})(window.jQuery);